import {Get} from "../axios.config";
/**
 * @author jiao 2021-01-05
 * 产品对接：王冕 服务端对接：东东 
 * getActivityList 活动主页 获取活动信息
 * 
 * method: get
 * url: /v1/payactivity/common_activity/combine_home_page_more
 * API文档: https://yapi.quickcan.com/project/347/interface/api/42768
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function getActivityList(params = {}){
    const url = "/v1/payactivity/common_activity/combine_home_page_more";
    // const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/combine_home_page_more";
    return Get({
        url: url,
        data: params
    });
}
/**
 * @author jiao 2021-01-05
 * 产品对接：王冕 服务端对接：东东 
 * getQueryOpenAuth 查询是否有活动充值权限
 * 
 * method: get
 * url: /v1/payactivity/common_activity/query_charge_auth
 * API文档: https://yapi.quickcan.com/project/347/interface/api/42780
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function getQueryOpenAuth(params = {}){
    const url = "/v1/payactivity/common_activity/query_charge_auth";
    // const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/query_charge_auth";
    return Get({
        url: url,
        data: params
    });
}




// WEBPACK FOOTER //
// ./src/api/pay/link_vip_double.api.js